module.exports = __webpack_public_path__ + "img/upload-file-icon-subject.6c3c6187.svg";